var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53123 1.46875C7.62498 0.5625 6.38123 0 4.99998 0C2.23748 0 0.00622559 2.2375 0.00622559 5C0.00622559 7.7625 2.23748 10 4.99998 10C7.33123 10 9.27497 8.40625 9.83123 6.25H8.53123C8.01873 7.70625 6.63123 8.75 4.99998 8.75C2.93123 8.75 1.24998 7.06875 1.24998 5C1.24998 2.93125 2.93123 1.25 4.99998 1.25C6.03748 1.25 6.96247 1.68125 7.63748 2.3625L5.62498 4.375H9.99998V0L8.53123 1.46875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.afac6c2fa582362c6cb3a7f376348c04.svg";
export { ForwardRef as ReactComponent };